var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9208 22.0951C16.5803 22.0951 17.1149 21.5834 17.1149 20.9522V4.23226L19.7904 7.2199C20.2195 7.69913 20.9733 7.75463 21.474 7.34386C21.9747 6.9331 22.0326 6.21161 21.6034 5.73239L16.8273 0.399098C16.6006 0.145782 16.2693 0 15.9208 0C15.5723 0 15.241 0.145782 15.0143 0.399098L10.2382 5.73239C9.809 6.21161 9.86698 6.9331 10.3677 7.34386C10.8684 7.75463 11.6221 7.69913 12.0513 7.2199L14.7268 4.23226V20.9522C14.7268 21.5834 15.2614 22.0951 15.9208 22.0951Z",
    fill: "url(#paint0_linear_26179_37148)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2885 11.8086C21.1706 11.8086 20.6116 11.8086 20.2101 12.0654C20.0362 12.1766 19.8869 12.3194 19.7708 12.4859C19.5024 12.8702 19.5024 13.4052 19.5024 14.4752V20.9514C19.5024 22.8449 17.8988 24.3799 15.9203 24.3799C13.9421 24.3799 12.3383 22.8449 12.3383 20.9514V14.4752C12.3383 13.4052 12.3383 12.8701 12.07 12.4858C11.9539 12.3194 11.8046 12.1766 11.6308 12.0654C11.2293 11.8086 10.6702 11.8086 9.5522 11.8086C5.04925 11.8086 2.79778 11.8086 1.39889 13.1475C0 14.4865 0 16.6412 0 20.9511V22.4749C0 26.7848 0 28.9398 1.39889 30.2787C2.79778 31.6177 5.04925 31.6177 9.5522 31.6177H22.2885C26.7914 31.6177 29.0428 31.6177 30.4418 30.2787C31.8407 28.9398 31.8407 26.7848 31.8407 22.4749V20.9511C31.8407 16.6412 31.8407 14.4865 30.4418 13.1475C29.0428 11.8086 26.7914 11.8086 22.2885 11.8086Z",
    fill: "url(#paint1_linear_26179_37148)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26179_37148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 40C24.477 40 20 35.523 20 30C20 24.477 24.477 20 30 20C35.523 20 40 24.477 40 30C40 35.523 35.523 40 30 40Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0474 28.618L28.5099 26.724C29.4552 25.4998 29.9279 24.8877 30.369 25.017C30.8099 25.1464 30.8099 25.8971 30.8099 27.3987V27.5402C30.8099 28.0818 30.8099 28.3526 30.9908 28.5224L31.0003 28.5312C31.185 28.6975 31.4794 28.6975 32.0683 28.6975C33.1281 28.6975 33.658 28.6975 33.8371 29.0051C33.84 29.0102 33.8429 29.0154 33.8457 29.0205C34.0148 29.3329 33.708 29.7302 33.0943 30.5248L31.6319 32.4188C30.6865 33.643 30.2138 34.2551 29.7728 34.1258C29.3318 33.9964 29.3318 33.2456 29.3318 31.7441L29.3318 31.6026C29.3318 31.061 29.3318 30.7902 29.151 30.6203L29.1414 30.6116C28.9568 30.4453 28.6623 30.4453 28.0734 30.4453C27.0136 30.4453 26.4838 30.4453 26.3047 30.1377C26.3017 30.1326 26.2988 30.1275 26.296 30.1222C26.127 29.8099 26.4338 29.4126 27.0474 28.618Z",
    fill: "url(#paint2_linear_26179_37148)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26179_37148",
    x: 11.1854,
    y: 11.1854,
    width: 37.6292,
    height: 37.6292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.4073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26179_37148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26179_37148",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26179_37148",
    x1: 9.95068,
    y1: 1.72618,
    x2: 26.6763,
    y2: 9.92502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26179_37148",
    x1: -1.28192e-7,
    y1: 13.3562,
    x2: 17.6971,
    y2: 39.1592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26179_37148",
    x1: 26.25,
    y1: 25.7143,
    x2: 34.6805,
    y2: 32.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCreate);
export default __webpack_public_path__ + "static/media/import-create.46417aada5d283ba26e0d337f33e2482.svg";
export { ForwardRef as ReactComponent };